// import React, { useContext, useEffect, useMemo, useState } from 'react';
// import { useParams, useHistory, Link } from 'react-router-dom/cjs/react-router-dom.min';
// import { Dropdown } from 'primereact/dropdown';
// import './CreateJob.css';
// import { GetMasterTypeData } from '../../../../Services/Global-Services/GlobalServices';
// import ERROR_LIST from '../../../../Services/Global-Services/Hadle_Errors';
// import { TostMsg } from '../../../../App';
// import { getJobList, getTalentRequestList, postJobSave } from './Service/RecruitmentService';
// import { getEmployeeList } from '../../EmployeeList/Service/employeeService';
// import { LazyImage } from '../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding';

// /* TODO: replace with your real JobStatus ids */
// const JOB_STATUS = { DRAFT: 1, OPEN: 101 };

// // Master APIs may return {Id, Name} or {id, name}
// const optId = (o) => o?.Id ?? o?.id ?? o?.VisibilityId ?? o?.Value ?? o?.value;
// const optName = (o) => o?.Name ?? o?.name ?? o?.VisibilityName ?? o?.Label ?? o?.label ?? '';

// const NAV_ITEMS = [
//   { id: 's-basic', icon: 'fa-circle-info', label: 'Basic Info' },
//   { id: 's-details', icon: 'fa-sliders', label: 'Job Details' },
//   { id: 's-comp', icon: 'fa-indian-rupee-sign', label: 'Compensation' },
//   { id: 's-must', icon: 'fa-star', label: 'Must Have' },
//   { id: 's-pref', icon: 'fa-thumbs-up', label: 'Preferred' },
//   { id: 's-jd', icon: 'fa-file-lines', label: 'Job Description' },
//   { id: 's-vis', icon: 'fa-eye', label: 'Visibility' },
// ];

// const emptyForm = {
//   TalentRequestId: '',
//   Title: '',
//   DepartmentId: '',
//   VisibilityId: '',
//   EmploymentTypeId: '',
//   WorkModeId: '',
//   Location: '',
//   NoticePeriodDays: '',
//   SalaryCurrencyCode: 'INR',
//   IsSalaryNegotiable: false,
//   NumberOfOpenings: 1,
//   JobDescription: '',
//   RecruiterEmpId: null,
//   ExperienceRangeId: '',
//   SalaryRangeId: '',
//   FeedbackAspects: 'default',
//   ExpectedJoiningDate: '',
// };

// const errTextStyle = { color: '#dc2626', fontSize: 12, marginTop: 4, display: 'block' };
// const errBorder = { borderColor: '#dc2626' };

// const CreateJob = () => {
//   const { Id } = useParams();
//   const jobId = Number(Id) || 0;
//   const isEdit = jobId > 0;
//   const history = useHistory();
//   const toster = useContext(TostMsg);
//   const userDetails = useMemo(() => JSON.parse(localStorage.getItem('User') || '{}'), []);

//   const [form, setForm] = useState(emptyForm);
//   const [errors, setErrors] = useState({});
//   const [jobCode, setJobCode] = useState('');
//   const [mustSkills, setMustSkills] = useState([]);
//   const [prefSkills, setPrefSkills] = useState([]);
//   const [mustBullets, setMustBullets] = useState(['']);
//   const [prefBullets, setPrefBullets] = useState(['']);
//   const [activeSection, setActiveSection] = useState('s-basic');
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);

//   const [departments, setDepartments] = useState([]);
//   const [visibilityList, setVisibilityList] = useState([]);
//   const [employmentTypeList, setEmploymentTypeList] = useState([]);
//   const [workModeList, setWorkModeList] = useState([]);
//   const [experienceRangeList, setExperienceRangeList] = useState([]);
//   const [salaryRangeList, setSalaryRangeList] = useState([]);
//   const [talentRequests, setTalentRequests] = useState([]);
//   const [employeeList, setEmployeeList] = useState([]);

//   const setField = (key, value) => {
//     setForm((prev) => ({ ...prev, [key]: value }));
//     setErrors((prev) => (prev[key] ? { ...prev, [key]: undefined } : prev));
//   };


//   /* ---------------- data loading ---------------- */

//   const loadMaster = async (masterType, setter) => {
//     try {
//       const response = await GetMasterTypeData({
//         masterType,
//         allRecords: true,
//         organisationId: userDetails?.OrgId,
//       });
//       setter(response?.Data || []);
//     } catch (error) {
//       toster?.current?.error('Failed to load ' + masterType);
//     }
//   };

//   const fetchTalentRequests = async () => {
//     try {
//       const response = await getTalentRequestList({
//         PageNumber: 1, PageSize: 100, SearchText: '', Status: '', Priority: '', DepartmentId: '', DateRaised: '',
//       });
//       setTalentRequests(response?.Data?.TalentRequests || []);
//     } catch (error) {
//       toster?.current?.error(ERROR_LIST?.TalentRequestList || 'Failed to load talent requests');
//       setTalentRequests([]);
//     }
//   };

//   const fetchEmployees = async () => {
//     try {
//       const res = await getEmployeeList({
//         OrganisationId: userDetails?.OrgId,
//         LoggedInEmployeeId: userDetails?.EmpId,
//         IsDirectReportOrHierarchy: 0,
//         SearchText: '',
//         FollowersOnly: 0,
//         FollowingsOnly: 0,
//         IsExEmployeesAlso: 0,
//         pageNumber: 1,
//         pageSize: 10000,
//         EmployeeId: 0,
//         IsSuggestedOnly: 0,
//       });
//       setEmployeeList(res?.Data || []);
//     } catch (error) {
//       setEmployeeList([]);
//     }
//   };

//   useEffect(() => {
//     loadMaster('Department', setDepartments);
//     loadMaster('PostingVisibility', setVisibilityList);
//     loadMaster('EmploymentType', setEmploymentTypeList);
//     loadMaster('WorkMode', setWorkModeList);
//     loadMaster('ExperienceRange', setExperienceRangeList);
//     loadMaster('SalaryRange', setSalaryRangeList);
//     fetchTalentRequests();
//     fetchEmployees();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // New job: default to first visibility option
//   useEffect(() => {
//     if (!isEdit && !form.VisibilityId && visibilityList.length) {
//       setField('VisibilityId', optId(visibilityList[0]));
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [visibilityList, isEdit]);

//   const splitList = (str, sep) => (str ? str.split(sep).map((s) => s.trim()).filter(Boolean) : []);

// const [existingStatusId, setExistingStatusId] = useState(null);

// const fetchJobForEdit = async () => {
//   if (!isEdit) return;
//   setLoading(true);
//   try {
//     const response = await getJobList({
//       JobId: jobId, Guid: '', TalentRequestId: 0, RecruiterEmpId: 0, JobStatusId: '', VisibilityId: '',
//       EmploymentTypeId: '', WorkModeId: '', DepartmentId: '', Location: '', Search: '', PageNumber: 1,
//       PageSize: 1, CreatedFrom: '', CreatedTo: '', SortBy: '', SortOrder: 'ASC', ExperienceRangeId: '',
//       SalaryRangeId: '', ExperienceMin: '', ExperienceMax: '',
//     });
//     const job = response?.Data?.Jobs?.[0];
//     if (!job) {
//       toster?.current?.error('Job not found');
//       return;
//     }

//     // Arrays from API -> UI state
//     const byType = (arr = [], type) =>
//       arr
//         .filter((x) => (x.RequirementType || '').toLowerCase() === type)
//         .sort((a, b) => (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0));

//     const skillTags = (type) =>
//       byType(job.Skills, type)
//         .flatMap((s) => (s.SkillName || '').split(','))   // saved as "jaca,css" -> ["jaca","css"]
//         .map((s) => s.trim())
//         .filter(Boolean);

//     const reqBullets = (type) =>
//       byType(job.Requirements, type)
//         .flatMap((r) => (r.RequirementText || '').split('\n'))
//         .map((s) => s.trim())
//         .filter(Boolean);

//     const must = reqBullets('must');
//     const pref = reqBullets('preferred');

//     const firstAspect = (job.FeedbackAspects?.[0]?.AspectName || '').toLowerCase();

//     setJobCode(job.JobCode || '');
//     setExistingStatusId(job.JobStatusId ?? null);
//     setForm({
//       TalentRequestId: job.TalentRequestId || '',
//       Title: job.Title || '',
//       DepartmentId: job.DepartmentId ?? '',
//       VisibilityId: job.VisibilityId ?? '',
//       EmploymentTypeId: job.EmploymentTypeId ?? '',
//       WorkModeId: job.WorkModeId ?? '',
//       Location: job.Location || '',
//       NoticePeriodDays: job.NoticePeriodDays ?? '',
//       SalaryCurrencyCode: job.SalaryCurrencyCode || 'INR',
//       IsSalaryNegotiable: !!job.IsSalaryNegotiable,
//       NumberOfOpenings: job.NumberOfOpenings ?? 1,
//       JobDescription: job.JobDescription || '',
//       RecruiterEmpId: job.RecruiterEmpId || null,
//       ExperienceRangeId: job.ExperienceRangeId ?? '',
//       SalaryRangeId: job.SalaryRangeId ?? '',
//       FeedbackAspects: firstAspect === 'custom' ? 'custom' : 'default',
//       ExpectedJoiningDate: '', // not returned by API
//     });
//     setMustSkills(skillTags('must'));
//     setPrefSkills(skillTags('preferred'));
//     setMustBullets(must.length ? must : ['']);
//     setPrefBullets(pref.length ? pref : ['']);
//   } catch (error) {
//     toster?.current?.error(ERROR_LIST?.TalentRequestList || 'Failed to load job');
//   } finally {
//     setLoading(false);
//   }
// };
//   useEffect(() => {
//     fetchJobForEdit();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [jobId]);

//   /* ---------------- scroll spy ---------------- */

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         const visible = entries.filter((e) => e.isIntersecting);
//         if (visible.length) setActiveSection(visible[0].target.id);
//       },
//       { rootMargin: '-20% 0px -65% 0px' }
//     );
//     NAV_ITEMS.forEach((n) => {
//       const el = document.getElementById(n.id);
//       if (el) observer.observe(el);
//     });
//     return () => observer.disconnect();
//   }, []);

//   const scrollTo = (id) => {
//     document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     setActiveSection(id);
//   };

//   /* ---------------- tags & bullets ---------------- */

//   const addTag = (e, type) => {
//     if (e.key !== 'Enter') return;
//     e.preventDefault();
//     const val = e.target.value.trim();
//     if (!val) return;
//     const setter = type === 'must' ? setMustSkills : setPrefSkills;
//     setter((prev) => (prev.some((s) => s.toLowerCase() === val.toLowerCase()) ? prev : [...prev, val]));
//     if (type === 'must') setErrors((p) => ({ ...p, MustSkills: undefined }));
//     e.target.value = '';
//   };

//   const removeTag = (index, type) => {
//     const setter = type === 'must' ? setMustSkills : setPrefSkills;
//     setter((prev) => prev.filter((_, i) => i !== index));
//   };

//   const bulletSetter = (type) => (type === 'must' ? setMustBullets : setPrefBullets);
//   const addBullet = (type) => bulletSetter(type)((prev) => [...prev, '']);
//   const updateBullet = (type, index, value) =>
//     bulletSetter(type)((prev) => prev.map((b, i) => (i === index ? value : b)));
//   const removeBullet = (type, index) =>
//     bulletSetter(type)((prev) => {
//       const next = prev.filter((_, i) => i !== index);
//       return next.length ? next : [''];
//     });

//   /* ---------------- validation ---------------- */

//   // Draft only needs a title; publishing needs everything required.
//   const validate = (mode) => {
//     const e = {};
//     if (!form.Title.trim()) e.Title = 'Job title is required';
//     else if (form.Title.trim().length < 3) e.Title = 'Job title must be at least 3 characters';

//     if (mode !== 'draft') {
//       if (!form.DepartmentId) e.DepartmentId = 'Please select a department';
//       if (!(Number(form.NumberOfOpenings) >= 1)) e.NumberOfOpenings = 'Openings must be at least 1';
//       if (!form.EmploymentTypeId) e.EmploymentTypeId = 'Please select an employment type';
//       if (!form.WorkModeId) e.WorkModeId = 'Please select a work mode';
//       if (!form.Location.trim()) e.Location = 'Location is required';
//       if (!form.ExperienceRangeId) e.ExperienceRangeId = 'Please select an experience range';
//       if (!mustSkills.length) e.MustSkills = 'Add at least one required skill (type and press Enter)';
//       if (!form.VisibilityId) e.VisibilityId = 'Please select who can see this job';
//       if (form.JobDescription.trim().length < 100)
//         e.JobDescription = 'Job description must be at least 100 characters';
//     }
//     return e;
//   };

//   const FIELD_ID = {
//     Title: 'f-Title',
//     DepartmentId: 'f-DepartmentId',
//     NumberOfOpenings: 'f-NumberOfOpenings',
//     EmploymentTypeId: 'f-EmploymentTypeId',
//     WorkModeId: 'f-WorkModeId',
//     Location: 'f-Location',
//     ExperienceRangeId: 'f-ExperienceRangeId',
//     MustSkills: 'mustSkillInput',
//     JobDescription: 'jobDesc',
//     VisibilityId: 's-vis',
//   };

//   const focusFirstError = (errs) => {
//     const first = Object.keys(FIELD_ID).find((k) => errs[k]);
//     if (!first) return;
//     const el = document.getElementById(FIELD_ID[first]);
//     el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
//     el?.focus?.();
//   };

//   /* ---------------- save ---------------- */

//   const saveJob = async (mode) => {
//     const errs = validate(mode);
//     setErrors(errs);
//     if (Object.keys(errs).length) {
//       const count = Object.values(errs).filter(Boolean).length;
//       toster?.current?.error(`Please fix ${count} highlighted field${count > 1 ? 's' : ''}`);
//       focusFirstError(errs);
//       return;
//     }

//     const payload = {
//       Id: isEdit ? jobId : 0,
//       TalentRequestId: Number(form.TalentRequestId) || 0,
//       Title: form.Title.trim(),
//       DepartmentId: Number(form.DepartmentId) || 0,
//       // JobStatusId: mode === 'draft' ? JOB_STATUS.DRAFT : JOB_STATUS.OPEN,
//       JobStatusId: 101,
//       VisibilityId: Number(form.VisibilityId) || 0,
//       EmploymentTypeId: Number(form.EmploymentTypeId) || 0,
//       WorkModeId: Number(form.WorkModeId) || 0,
//       Location: form.Location.trim(),
//       NoticePeriodDays: Number(form.NoticePeriodDays) || 0,
//       SalaryCurrencyCode: form.SalaryCurrencyCode || 'INR',
//       IsSalaryNegotiable: !!form.IsSalaryNegotiable,
//       NumberOfOpenings: Number(form.NumberOfOpenings) || 1,
//       JobDescription: form.JobDescription,
//       RecruiterEmpId: Number(form.RecruiterEmpId) || 0,
//       RequirementsMust: mustBullets.map((b) => b.trim()).filter(Boolean).join('\n'),
//       RequirementsPref: prefBullets.map((b) => b.trim()).filter(Boolean).join('\n'),
//       SkillsMust: mustSkills.join(','),
//       SkillsPref: prefSkills.join(','),
//       FeedbackAspects: form.FeedbackAspects || '',
//       ExperienceRangeId: Number(form.ExperienceRangeId) || 0,
//       SalaryRangeId: Number(form.SalaryRangeId) || 0,
//     };

//     setSubmitting(true);
//     try {
//       const response = await postJobSave(payload);
//       const code = response?.Data?.JobCode || jobCode || '';
//       toster?.current?.success(
//         isEdit
//           ? `Job updated — ${code}`
//           : mode === 'draft'
//             ? `Job saved as Draft — ${code}`
//             : `Job created and published — ${code}`
//       );
//       setTimeout(() => history.push('/Recruitment/JobsPage'), 1200);
//     } catch (err) {
//       toster?.current?.error(ERROR_LIST?.TalentRequestList || 'Failed to save job');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const discard = () => {
//     if (window.confirm('Discard changes and go back?')) history.push('/Recruitment/JobsPage');
//   };

//   /* ---------------- render helpers ---------------- */

//   const ErrMsg = ({ name }) => (errors[name] ? <span style={errTextStyle}>{errors[name]}</span> : null);
//   const bs = (name) => (errors[name] ? errBorder : undefined);

//   const renderOptions = (list) =>
//     list.map((o) => (
//       <option key={optId(o)} value={optId(o)}>
//         {optName(o)}
//       </option>
//     ));

//   const talentRequestLabel = (t) =>
//     [t.TalentRequestCode || t.Code || `TR-${t.Id ?? t.id}`, t.Title || t.JobTitle || t.RoleName || t.name]
//       .filter(Boolean)
//       .join(' · ');

//   const visibilityHint = (name = '') => {
//     const n = name.toLowerCase();
//     if (n.includes('both')) return 'Internal employees + public ATS listing';
//     if (n.includes('external')) return 'Public on ats.orggenie.com for all applicants';
//     if (n.includes('internal')) return 'Visible to existing employees for internal moves';
//     return '';
//   };

//   const employeeOptionTemplate = (option) => (
//     <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
//       <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
//       <span>{option.FullName}</span>
//     </div>
//   );

//   const charCount = form.JobDescription.length;

//   const renderBullets = (type, list, numClass) =>
//     list.map((value, idx) => (
//       <li className="bullet-item" key={`${type}-${idx}`}>
//         <span className={`bullet-num ${numClass || ''}`}>{idx + 1}</span>
//         <input
//           className="bullet-input"
//           value={value}
//           placeholder="Add a criterion…"
//           onChange={(e) => updateBullet(type, idx, e.target.value)}
//         />
//         <button type="button" className="bullet-remove" onClick={() => removeBullet(type, idx)}>
//           <i className="fa-solid fa-times bullet-remove-icon"></i>
//         </button>
//       </li>
//     ));

//   const renderTags = (list, type, inputId, errorKey) => (
//     <>
//       <div
//         className="tag-input-wrap"
//         style={errorKey ? bs(errorKey) : undefined}
//         onClick={() => document.getElementById(inputId)?.focus()}
//       >
//         {list.map((skill, idx) => (
//           <span className={`tag-item ${type}`} key={`${skill}-${idx}`}>
//             {skill}
//             <button type="button" onClick={() => removeTag(idx, type)}>×</button>
//           </span>
//         ))}
//         <input
//           id={inputId}
//           className="tag-text-input"
//           placeholder="Type and press Enter…"
//           onKeyDown={(e) => addTag(e, type)}
//         />
//       </div>
//       {errorKey && <ErrMsg name={errorKey} />}
//     </>
//   );

//   /* ---------------- render ---------------- */

//   return (
//     <>
//       <div className="topbar">
//         <i className="fa-solid fa-briefcase"></i>
//         <div className="breadcrumb topbar-breadcrumb">
//           <a>Recruitment</a>
//           <i className="fa-solid fa-chevron-right"></i>
//           <a>Jobs</a>
//           <i className="fa-solid fa-chevron-right"></i>
//           <strong className="topbar-current">{isEdit ? 'Edit Job' : 'Create Job'}</strong>
//         </div>
//         <div className="top-right">
//           <div className="top-user">
//             <div className="top-avatar">AM</div>
//             <div>
//               <div className="top-user-name"> Arun Mishra </div>
//               <div className="top-user-role"> HR Admin </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="container-fluid position-relation">
//         <div className="page-hd">
//           <div className="Page-head">
//             <div className="leftside-head">
//               <h2>
//                 <i className={`fa-solid ${isEdit ? 'fa-pen' : 'fa-plus-circle'}`}></i>
//                 {isEdit ? 'Edit Job' : 'Create Job'}
//               </h2>
//               <div className="breadcrumb">Fill in job details, requirements and visibility settings</div>
//             </div>
//             <Link to="/Recruitment/JobsPage" className="btn btn-outline btn-sm btn-gray">
//               <i className="fa-solid fa-arrow-left"></i> Back
//             </Link>
//           </div>
//         </div>

//         <div className="form-layout">
//           <div className="form-nav">
//             {NAV_ITEMS.map((item) => (
//               <div
//                 key={item.id}
//                 className={`fn-item ${activeSection === item.id ? 'active' : ''}`}
//                 onClick={() => scrollTo(item.id)}
//               >
//                 <i className={`fa-solid ${item.icon}`}></i> {item.label}
//               </div>
//             ))}
//           </div>

//           <div className="form-sections">
//             {loading && <div className="job-id-preview">Loading…</div>}

//             <div className="job-id-preview">
//               <i className="fa-solid fa-hashtag"></i>
//               <strong>{jobCode || 'JOB-XXXX-XXX'}</strong>
//               <span>{isEdit ? 'Job code · read-only' : 'Auto-generated on save · read-only'}</span>
//             </div>

//             {/* SECTION 1 - Basic Info */}
//             <div className="fs-bx" id="s-basic">
//               <div className="fs-head">
//                 <i className="fs-icon fa-solid fa-circle-info"></i>
//                 <h4>Basic Information</h4>
//               </div>
//               <div className="fs-body">
//                 <div className="form-row form-row-1">
//                   <div className="fg">
//                     <label>Job Title <span className="req">*</span></label>
//                     <input
//                       id="f-Title"
//                       className="og-input"
//                       style={bs('Title')}
//                       placeholder="e.g. Senior Product Designer"
//                       value={form.Title}
//                       onChange={(e) => setField('Title', e.target.value)}
//                     />
//                     <ErrMsg name="Title" />
//                   </div>
//                 </div>

//                 <div className="form-row form-row-2">
//                   <div className="fg">
//                     <label>Department <span className="req">*</span></label>
//                     <select
//                       id="f-DepartmentId"
//                       className="og-select"
//                       style={bs('DepartmentId')}
//                       value={form.DepartmentId}
//                       onChange={(e) => setField('DepartmentId', e.target.value)}
//                     >
//                       <option value="">Select department</option>
//                       {renderOptions(departments)}
//                     </select>
//                     <ErrMsg name="DepartmentId" />
//                   </div>

//                   <div className="fg">
//                     <label>Number of Openings <span className="req">*</span></label>
//                     <input
//                       id="f-NumberOfOpenings"
//                       className="og-input"
//                       style={bs('NumberOfOpenings')}
//                       type="number"
//                       min="1"
//                       placeholder="1"
//                       value={form.NumberOfOpenings}
//                       onChange={(e) => setField('NumberOfOpenings', e.target.value)}
//                     />
//                     <ErrMsg name="NumberOfOpenings" />
//                   </div>
//                 </div>

//                 <div className="form-row form-row-1">
//                   <div className="fg">
//                     <label>Link to Talent Request <span className="opt">(optional)</span></label>
//                     <select
//                       className="og-select"
//                       value={form.TalentRequestId}
//                       onChange={(e) => setField('TalentRequestId', e.target.value)}
//                     >
//                       <option value="">None — standalone job</option>
//                       {talentRequests.map((t) => (
//                         <option key={t.Id ?? t.id} value={t.Id ?? t.id}>
//                           {talentRequestLabel(t)}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* SECTION 2 - Job Details */}
//             <div className="fs-bx" id="s-details">
//               <div className="fs-head">
//                 <i className="fs-icon fa-solid fa-sliders"></i>
//                 <h4>Job Details</h4>
//               </div>
//               <div className="fs-body">
//                 <div className="form-row form-row-3">
//                   <div className="fg">
//                     <label>Employment Type <span className="req">*</span></label>
//                     <select
//                       id="f-EmploymentTypeId"
//                       className="og-select"
//                       style={bs('EmploymentTypeId')}
//                       value={form.EmploymentTypeId}
//                       onChange={(e) => setField('EmploymentTypeId', e.target.value)}
//                     >
//                       <option value="">Select type</option>
//                       {renderOptions(employmentTypeList)}
//                     </select>
//                     <ErrMsg name="EmploymentTypeId" />
//                   </div>

//                   <div className="fg">
//                     <label>Work Mode <span className="req">*</span></label>
//                     <select
//                       id="f-WorkModeId"
//                       className="og-select"
//                       style={bs('WorkModeId')}
//                       value={form.WorkModeId}
//                       onChange={(e) => setField('WorkModeId', e.target.value)}
//                     >
//                       <option value="">Select work mode</option>
//                       {renderOptions(workModeList)}
//                     </select>
//                     <ErrMsg name="WorkModeId" />
//                   </div>

//                   <div className="fg">
//                     <label>Location <span className="req">*</span></label>
//                     <input
//                       id="f-Location"
//                       className="og-input"
//                       style={bs('Location')}
//                       placeholder="City or Remote"
//                       value={form.Location}
//                       onChange={(e) => setField('Location', e.target.value)}
//                     />
//                     <ErrMsg name="Location" />
//                   </div>
//                 </div>

//                 <div className="form-row form-row-2">
//                   <div className="fg">
//                     <label>Experience Range <span className="req">*</span></label>
//                     <select
//                       id="f-ExperienceRangeId"
//                       className="og-select"
//                       style={bs('ExperienceRangeId')}
//                       value={form.ExperienceRangeId}
//                       onChange={(e) => setField('ExperienceRangeId', e.target.value)}
//                     >
//                       <option value="">Select experience</option>
//                       {renderOptions(experienceRangeList)}
//                     </select>
//                     <ErrMsg name="ExperienceRangeId" />
//                   </div>

//                   <div className="fg">
//                     <label>Expected Joining Date</label>
//                     <input
//                       className="og-input experience-input"
//                       type="date"
//                       value={form.ExpectedJoiningDate}
//                       onChange={(e) => setField('ExpectedJoiningDate', e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* SECTION 3 - Compensation */}
//             <div className="fs-bx" id="s-comp">
//               <div className="fs-head">
//                 <i className="fs-icon fa-solid fa-indian-rupee-sign"></i>
//                 <h4>Compensation</h4>
//               </div>
//               <div className="fs-body">
//                 <div className="form-row form-row-2">
//                   <div className="fg">
//                     <label>Salary</label>
//                     <select
//                       className="og-select"
//                       value={form.SalaryRangeId}
//                       onChange={(e) => setField('SalaryRangeId', e.target.value)}
//                     >
//                       <option value="">Select salary range</option>
//                       {renderOptions(salaryRangeList)}
//                     </select>
//                   </div>
//                 </div>

//                 <label className="negotiable-label">
//                   <input
//                     type="checkbox"
//                     checked={form.IsSalaryNegotiable}
//                     onChange={(e) => setField('IsSalaryNegotiable', e.target.checked)}
//                   />
//                   Mark as negotiable — exact range hidden from candidates
//                 </label>
//               </div>
//             </div>

//             {/* SECTION 4 - Must Have */}
//             <div className="fs-bx" id="s-must">
//               <div className="fs-head">
//                 <i className="fs-icon fa-solid fa-star"></i>
//                 <h4>Must Have Requirements</h4>
//                 <span className="fs-subtitle">Non-negotiable qualifications</span>
//               </div>
//               <div className="fs-body">
//                 <div className="form-row form-row-1">
//                   <div className="fg">
//                     <label>Required Skills <span className="req">*</span></label>
//                     {renderTags(mustSkills, 'must', 'mustSkillInput', 'MustSkills')}
//                   </div>
//                 </div>

//                 <div className="form-row form-row-1">
//                   <div className="fg">
//                     <label>
//                       Must-have criteria <span className="opt">— bullet points shown in job posting</span>
//                     </label>
//                     <ul className="bullet-list" id="mustList">
//                       {renderBullets('must', mustBullets)}
//                     </ul>
//                     <button type="button" className="add-bullet-btn" onClick={() => addBullet('must')}>
//                       <i className="fa-solid fa-plus bullet-remove-icon"></i>
//                       Add criterion
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* SECTION 5 - Preferred */}
//             <div className="fs-bx" id="s-pref">
//               <div className="fs-head">
//                 <i className="fs-icon fa-solid fa-thumbs-up"></i>
//                 <h4>Preferred Requirements</h4>
//                 <span className="fs-subtitle">Nice-to-have qualifications</span>
//               </div>
//               <div className="fs-body">
//                 <div className="form-row form-row-1">
//                   <div className="fg">
//                     <label>Preferred Skills <span className="opt">(nice to have)</span></label>
//                     {renderTags(prefSkills, 'pref', 'prefSkillInput')}
//                   </div>
//                 </div>

//                 <div className="form-row form-row-1">
//                   <div className="fg">
//                     <label>Preferred criteria <span className="opt">— bonus qualifications</span></label>
//                     <ul className="bullet-list" id="prefList">
//                       {renderBullets('pref', prefBullets, 'bullet-num-green')}
//                     </ul>
//                     <button
//                       type="button"
//                       className="add-bullet-btn add-bullet-green"
//                       onClick={() => addBullet('pref')}
//                     >
//                       <i className="fa-solid fa-plus bullet-remove-icon"></i>
//                       Add criterion
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* SECTION 6 - Job Description */}
//             <div className="fs-bx" id="s-jd">
//               <div className="fs-head">
//                 <i className="fs-icon fa-solid fa-file-lines"></i>
//                 <h4>Job Description</h4>
//               </div>
//               <div className="fs-body">
//                 <textarea
//                   className="og-textarea"
//                   style={bs('JobDescription')}
//                   rows="12"
//                   id="jobDesc"
//                   value={form.JobDescription}
//                   onChange={(e) => setField('JobDescription', e.target.value)}
//                   placeholder={`Describe the role, team context, day-to-day responsibilities, and what success looks like in this position.

// Example:
// We are looking for a Senior Frontend Developer to join our growing engineering team at BizBrolly. You will work closely with designers and backend engineers to build delightful, high-performance user interfaces for OrgGenie, our flagship SaaS product.

// Responsibilities:
// • Build and maintain reusable UI components
// • Collaborate with design team on new features
// • Participate in code reviews and architectural discussions`}
//                 ></textarea>
//                 <ErrMsg name="JobDescription" />

//                 <div className="description-footer">
//                   <span className="description-info">Minimum 100 characters required to publish</span>
//                   <span id="charCount" className="char-count">
//                     {charCount} character{charCount === 1 ? '' : 's'}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* SECTION 7 - Visibility */}
//             <div className="fs-bx" id="s-vis">
//               <div className="fs-head">
//                 <i className="fs-icon fa-solid fa-eye"></i>
//                 <h4>Visibility &amp; Publishing</h4>
//               </div>
//               <div className="fs-body">
//                 <div className="fg visibility-field">
//                   <label>Who can see this job? <span className="req">*</span></label>
//                   <div className="vis-options">
//                     {visibilityList.length === 0 && (
//                       <div className="feedback-note">
//                         Visibility options could not be loaded. Refresh the page or contact admin.
//                       </div>
//                     )}
//                     {visibilityList.map((v) => {
//                       const vid = optId(v);
//                       const selected = String(form.VisibilityId) === String(vid);
//                       return (
//                         <div
//                           key={vid}
//                           className={`vis-opt ${selected ? 'selected' : ''}`}
//                           onClick={() => setField('VisibilityId', vid)}
//                         >
//                           <input
//                             type="radio"
//                             name="vis"
//                             checked={selected}
//                             onChange={() => setField('VisibilityId', vid)}
//                           />
//                           <div>
//                             <div className="vis-opt-label">{optName(v)}</div>
//                             <div className="vis-opt-sub">{visibilityHint(optName(v))}</div>
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                   <ErrMsg name="VisibilityId" />
//                 </div>

//                 <div className="form-row form-row-2">
//                   <div className="fg">
//                     <label>Assigned Recruiter</label>
//                     <Dropdown
//                       className="w-full"
//                       value={form.RecruiterEmpId}
//                       onChange={(e) => setField('RecruiterEmpId', e.value)}
//                       options={employeeList}
//                       optionLabel="FullName"
//                       optionValue="EmployeeId" /* change to the id field your employee API returns */
//                       itemTemplate={employeeOptionTemplate}
//                       filter
//                       showClear
//                       placeholder="Select recruiter"
//                     />
//                   </div>

//                   <div className="fg">
//                     <label>Feedback Aspects <span className="opt">— used in interviews</span></label>
//                     <select
//                       className="og-select"
//                       value={form.FeedbackAspects}
//                       onChange={(e) => setField('FeedbackAspects', e.target.value)}
//                     >
//                       <option value="101">Use org default aspects</option>
//                       <option value="102">Customise for this job</option>
//                     </select>
//                   </div>
//                 </div>

//                 {form.FeedbackAspects === '102' && (
//                   <div id="feedbackNote" className="feedback-note">
//                     <i className="fa-solid fa-circle-info"></i>
//                     You can add or edit feedback aspects after creating the job, from the interview round setup.
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="form-bottom-space"></div>
//           </div>
//         </div>
//       </div>

//       {/* Form Footer */}
//       <div className="form-footer">
//         <button type="button" className="btn btn-outline btn-sm" disabled={submitting} onClick={discard}>
//           Discard
//         </button>
//         <button
//           type="button"
//           className="btn btn-outline btn-sm"
//           disabled={submitting}
//           onClick={() => saveJob('draft')}
//         >
//           <i className="fa-regular fa-floppy-disk"></i> Save as Draft
//         </button>
//         <button
//           type="button"
//           className="btn btn-primary btn-sm"
//           disabled={submitting}
//           onClick={() => saveJob('active')}
//         >
//           <i className="fa-solid fa-check"></i>{' '}
//           {submitting ? 'Saving…' : isEdit ? 'Update & Publish' : 'Create & Publish'}
//         </button>
//       </div>
//     </>
//   );
// };

// export default CreateJob;


import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom/cjs/react-router-dom.min';
import { MultiSelect } from 'primereact/multiselect';
import './CreateJob.css';
import { GetMasterTypeData } from '../../../../Services/Global-Services/GlobalServices';
import ERROR_LIST from '../../../../Services/Global-Services/Hadle_Errors';
import { TostMsg } from '../../../../App';
import { getJobList, getTalentRequestList, postJobSave } from './Service/RecruitmentService';
import { getEmployeeList } from '../../EmployeeList/Service/employeeService';
import { LazyImage } from '../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding';

/* Feedback aspect type ids (adjust if your backend uses different ids) */
const FEEDBACK_TYPE = { DEFAULT: 101, CUSTOM: 102 };

const MIN_DESC_LENGTH = 100;

// Master APIs may return {Id, Name} or {id, name}
const optId = (o) => o?.Id ?? o?.id ?? o?.VisibilityId ?? o?.Value ?? o?.value;
const optName = (o) => o?.Name ?? o?.name ?? o?.VisibilityName ?? o?.Label ?? o?.label ?? '';

const NAV_ITEMS = [
  { id: 's-basic', icon: 'fa-circle-info', label: 'Basic Info' },
  { id: 's-details', icon: 'fa-sliders', label: 'Job Details' },
  { id: 's-comp', icon: 'fa-indian-rupee-sign', label: 'Compensation' },
  { id: 's-must', icon: 'fa-star', label: 'Must Have' },
  { id: 's-pref', icon: 'fa-thumbs-up', label: 'Preferred' },
  { id: 's-jd', icon: 'fa-file-lines', label: 'Job Description' },
  { id: 's-vis', icon: 'fa-eye', label: 'Visibility' },
];

const emptyForm = {
  TalentRequestId: '',
  Title: '',
  DepartmentId: '',
  VisibilityId: '',
  EmploymentTypeId: '',
  WorkModeId: '',
  Location: '',
  NoticePeriodDays: '',
  SalaryCurrencyCode: 'INR',
  IsSalaryNegotiable: false,
  NumberOfOpenings: 1,
  JobDescription: '',
  RecruiterEmpIds: [],
  ExperienceRangeId: '',
  SalaryRangeId: '',
  FeedbackAspectTypeId: FEEDBACK_TYPE.DEFAULT,
  ExpectedStartDate: '',
};

const errTextStyle = { color: '#dc2626', fontSize: 12, marginTop: 4, display: 'block' };
const errBorder = { borderColor: '#dc2626' };

const CreateJob = () => {
  const { Id } = useParams();
  const jobId = Number(Id) || 0;
  const isEdit = jobId > 0;
  const history = useHistory();
  const toster = useContext(TostMsg);
  const userDetails = useMemo(() => JSON.parse(localStorage.getItem('User') || '{}'), []);

  const [form, setForm] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [jobCode, setJobCode] = useState('');
  const [mustSkills, setMustSkills] = useState([]);
  const [prefSkills, setPrefSkills] = useState([]);
  const [mustBullets, setMustBullets] = useState(['']);
  const [prefBullets, setPrefBullets] = useState(['']);
  const [activeSection, setActiveSection] = useState('s-basic');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [departments, setDepartments] = useState([]);
  const [visibilityList, setVisibilityList] = useState([]);
  const [employmentTypeList, setEmploymentTypeList] = useState([]);
  const [workModeList, setWorkModeList] = useState([]);
  const [experienceRangeList, setExperienceRangeList] = useState([]);
  const [salaryRangeList, setSalaryRangeList] = useState([]);
  const [talentRequests, setTalentRequests] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  const setField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => (prev[key] ? { ...prev, [key]: undefined } : prev));
  };

  /* ---------------- data loading ---------------- */

  const loadMaster = async (masterType, setter) => {
    try {
      const response = await GetMasterTypeData({
        masterType,
        allRecords: true,
        organisationId: userDetails?.OrgId,
      });
      setter(response?.Data || []);
    } catch (error) {
      toster?.current?.error('Failed to load ' + masterType);
    }
  };

  const fetchTalentRequests = async () => {
    try {
      const response = await getTalentRequestList({
        PageNumber: 1, PageSize: 100, SearchText: '', Status: '', Priority: '', DepartmentId: '', DateRaised: '',
      });
      setTalentRequests(response?.Data?.TalentRequests || []);
    } catch (error) {
      toster?.current?.error(ERROR_LIST?.TalentRequestList || 'Failed to load talent requests');
      setTalentRequests([]);
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await getEmployeeList({
        OrganisationId: userDetails?.OrgId,
        LoggedInEmployeeId: userDetails?.EmpId,
        IsDirectReportOrHierarchy: 0,
        SearchText: '',
        FollowersOnly: 0,
        FollowingsOnly: 0,
        IsExEmployeesAlso: 0,
        pageNumber: 1,
        pageSize: 10000,
        EmployeeId: 0,
        IsSuggestedOnly: 0,
      });

      // Normalise: every row gets a unique numeric `_id`.
      // (If optionValue points to a field that doesn't exist, every option has the
      // same value `undefined` and one click selects ALL rows.)
      const seen = new Set();
      const list = (res?.Data || [])
        .map((e) => ({ ...e, _id: Number(e.EmployeeId ?? e.EmpId ?? e.Id ?? e.UserId) }))
        .filter((e) => {
          if (!e._id || seen.has(e._id)) return false;
          seen.add(e._id);
          return true;
        });

      setEmployeeList(list);
    } catch (error) {
      setEmployeeList([]);
    }
  };

  useEffect(() => {
    loadMaster('Department', setDepartments);
    loadMaster('PostingVisibility', setVisibilityList);
    loadMaster('EmploymentType', setEmploymentTypeList);
    loadMaster('WorkMode', setWorkModeList);
    loadMaster('ExperienceRange', setExperienceRangeList);
    loadMaster('SalaryRange', setSalaryRangeList);
    fetchTalentRequests();
    fetchEmployees();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // New job: default to first visibility option
  useEffect(() => {
    if (!isEdit && !form.VisibilityId && visibilityList.length) {
      setField('VisibilityId', optId(visibilityList[0]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibilityList, isEdit]);

  const fetchJobForEdit = async () => {
    if (!isEdit) return;
    setLoading(true);
    try {
      const response = await getJobList({
        JobId: jobId,
        Guid: '',
        TalentRequestId: 0,
        RecruiterEmpId: 0,
        JobStatusId: '',
        VisibilityId: '',
        EmploymentTypeId: '',
        WorkModeId: '',
        DepartmentId: '',
        Search: '',
        CreatedFrom: '',
        CreatedTo: '',
        PageNumber: 1,
        PageSize: 1,
        SortBy: '',
        SortOrder: '',
        ExperienceRangeId: '',
        SalaryRangeId: '',
        IsPublished: 0,
        Location: '',
        ExperienceMin: 0,
        ExperienceMax: 0,
        PostedAfter: '',
        CreatedByEmpId: 0,
      });
      const job = response?.Data?.Jobs?.[0];
      if (!job) {
        toster?.current?.error('Job not found');
        return;
      }

      // Arrays from API -> UI state
      const byType = (arr = [], type) =>
        arr
          .filter((x) => (x.RequirementType || '').toLowerCase() === type)
          .sort((a, b) => (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0));

      const skillTags = (type) =>
        byType(job.Skills, type)
          .flatMap((s) => (s.SkillName || '').split(',')) // saved as "java,css" -> ["java","css"]
          .map((s) => s.trim())
          .filter(Boolean);

      const reqBullets = (type) =>
        byType(job.Requirements, type)
          .flatMap((r) => (r.RequirementText || '').split('\n'))
          .map((s) => s.trim())
          .filter(Boolean);

      const must = reqBullets('must');
      const pref = reqBullets('preferred');

      const firstAspect = (job.FeedbackAspects?.[0]?.AspectName || '').toLowerCase();

      // support RecruiterEmpIds[], a Recruiters[] list, or the old single id
      const recruiterIds =
        job.RecruiterEmpIds ??
        job.Recruiters?.map((r) => r.EmployeeId ?? r.EmpId) ??
        (job.RecruiterEmpId ? [job.RecruiterEmpId] : []);

      setJobCode(job.JobCode || '');
      setForm({
        TalentRequestId: job.TalentRequestId || '',
        Title: job.Title || '',
        DepartmentId: job.DepartmentId ?? '',
        VisibilityId: job.VisibilityId ?? '',
        EmploymentTypeId: job.EmploymentTypeId ?? '',
        WorkModeId: job.WorkModeId ?? '',
        Location: job.Location || '',
        NoticePeriodDays: job.NoticePeriodDays ?? '',
        SalaryCurrencyCode: job.SalaryCurrencyCode || 'INR',
        IsSalaryNegotiable: !!job.IsSalaryNegotiable,
        NumberOfOpenings: job.NumberOfOpenings ?? 1,
        JobDescription: job.JobDescription || '',
        RecruiterEmpIds: (recruiterIds || []).filter(Boolean).map(Number),
        ExperienceRangeId: job.ExperienceRangeId ?? '',
        SalaryRangeId: job.SalaryRangeId ?? '',
        FeedbackAspectTypeId:
          job.FeedbackAspectTypeId ||
          (firstAspect === 'custom' ? FEEDBACK_TYPE.CUSTOM : FEEDBACK_TYPE.DEFAULT),
        ExpectedStartDate: job.ExpectedStartDate ? String(job.ExpectedStartDate).slice(0, 10) : '',
      });
      setMustSkills(skillTags('must'));
      setPrefSkills(skillTags('preferred'));
      setMustBullets(must.length ? must : ['']);
      setPrefBullets(pref.length ? pref : ['']);
    } catch (error) {
      toster?.current?.error(ERROR_LIST?.JobLoad || ERROR_LIST?.TalentRequestList || 'Failed to load job');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobForEdit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);

  /* ---------------- scroll spy ---------------- */

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((e) => e.isIntersecting);
        if (visible.length) setActiveSection(visible[0].target.id);
      },
      { rootMargin: '-20% 0px -65% 0px' }
    );
    NAV_ITEMS.forEach((n) => {
      const el = document.getElementById(n.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActiveSection(id);
  };

  /* ---------------- tags & bullets ---------------- */

  const addTag = (e, type) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const val = e.target.value.trim();
    if (!val) return;
    const setter = type === 'must' ? setMustSkills : setPrefSkills;
    setter((prev) => (prev.some((s) => s.toLowerCase() === val.toLowerCase()) ? prev : [...prev, val]));
    if (type === 'must') setErrors((p) => ({ ...p, MustSkills: undefined }));
    e.target.value = '';
  };

  const removeTag = (index, type) => {
    const setter = type === 'must' ? setMustSkills : setPrefSkills;
    setter((prev) => prev.filter((_, i) => i !== index));
  };

  const bulletSetter = (type) => (type === 'must' ? setMustBullets : setPrefBullets);
  const addBullet = (type) => bulletSetter(type)((prev) => [...prev, '']);
  const updateBullet = (type, index, value) =>
    bulletSetter(type)((prev) => prev.map((b, i) => (i === index ? value : b)));
  const removeBullet = (type, index) =>
    bulletSetter(type)((prev) => {
      const next = prev.filter((_, i) => i !== index);
      return next.length ? next : [''];
    });

  /* ---------------- validation ---------------- */

  // Same value is used for the live counter AND validation (trimmed length).
  const descLength = form.JobDescription.trim().length;

  // Draft only needs a title (and, if a description is typed, it must be long enough).
  // Publishing needs everything required.
  const validate = (mode) => {
    const e = {};
    if (!form.Title.trim()) e.Title = 'Job title is required';
    else if (form.Title.trim().length < 3) e.Title = 'Job title must be at least 3 characters';

    if (mode !== 'draft') {
      if (!form.DepartmentId) e.DepartmentId = 'Please select a department';
      if (!(Number(form.NumberOfOpenings) >= 1)) e.NumberOfOpenings = 'Openings must be at least 1';
      if (!form.EmploymentTypeId) e.EmploymentTypeId = 'Please select an employment type';
      if (!form.WorkModeId) e.WorkModeId = 'Please select a work mode';
      if (!form.Location.trim()) e.Location = 'Location is required';
      if (!form.ExperienceRangeId) e.ExperienceRangeId = 'Please select an experience range';
      if (!mustSkills.length) e.MustSkills = 'Add at least one required skill (type and press Enter)';
      if (!form.VisibilityId) e.VisibilityId = 'Please select who can see this job';
      if (descLength === 0) e.JobDescription = 'Job description is required';
      else if (descLength < MIN_DESC_LENGTH)
        e.JobDescription = `Job description must be at least ${MIN_DESC_LENGTH} characters (currently ${descLength})`;
    } else if (descLength > 0 && descLength < MIN_DESC_LENGTH) {
      // Draft: description is optional, but if started it must meet the minimum
      e.JobDescription = `Job description must be at least ${MIN_DESC_LENGTH} characters (currently ${descLength})`;
    }
    return e;
  };

  const FIELD_ID = {
    Title: 'f-Title',
    DepartmentId: 'f-DepartmentId',
    NumberOfOpenings: 'f-NumberOfOpenings',
    EmploymentTypeId: 'f-EmploymentTypeId',
    WorkModeId: 'f-WorkModeId',
    Location: 'f-Location',
    ExperienceRangeId: 'f-ExperienceRangeId',
    MustSkills: 'mustSkillInput',
    JobDescription: 'jobDesc',
    VisibilityId: 's-vis',
  };

  const focusFirstError = (errs) => {
    const first = Object.keys(FIELD_ID).find((k) => errs[k]);
    if (!first) return;
    const el = document.getElementById(FIELD_ID[first]);
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el?.focus?.();
  };

  /* ---------------- save ---------------- */

  const saveJob = async (mode) => {
    const errs = validate(mode);
    setErrors(errs);
    if (Object.keys(errs).some((k) => errs[k])) {
      const count = Object.values(errs).filter(Boolean).length;
      toster?.current?.error(`Please fix ${count} highlighted field${count > 1 ? 's' : ''}`);
      focusFirstError(errs);
      return;
    }

    const feedbackTypeId = Number(form.FeedbackAspectTypeId) || FEEDBACK_TYPE.DEFAULT;

    const payload = {
      Id: isEdit ? jobId : 0,
      TalentRequestId: Number(form.TalentRequestId) || 0,
      Title: form.Title.trim(),
      DepartmentId: Number(form.DepartmentId) || 0,
      VisibilityId: Number(form.VisibilityId) || 0,
      ExpectedStartDate: form.ExpectedStartDate || null,
      EmploymentTypeId: Number(form.EmploymentTypeId) || 0,
      WorkModeId: Number(form.WorkModeId) || 0,
      Location: form.Location.trim(),
      NoticePeriodDays: Number(form.NoticePeriodDays) || 0,
      SalaryCurrencyCode: form.SalaryCurrencyCode || 'INR',
      IsSalaryNegotiable: !!form.IsSalaryNegotiable,
      NumberOfOpenings: Number(form.NumberOfOpenings) || 1,
      JobDescription: form.JobDescription.trim(),
      RecruiterEmpIds: (form.RecruiterEmpIds || []).map(Number).filter(Boolean),
      RequirementsMust: mustBullets.map((b) => b.trim()).filter(Boolean).join('\n'),
      RequirementsPref: prefBullets.map((b) => b.trim()).filter(Boolean).join('\n'),
      SkillsMust: mustSkills.join(','),
      SkillsPref: prefSkills.join(','),
      FeedbackAspectTypeId: feedbackTypeId,
      FeedbackAspects: feedbackTypeId === FEEDBACK_TYPE.CUSTOM ? 'custom' : 'default',
      ExperienceRangeId: Number(form.ExperienceRangeId) || 0,
      SalaryRangeId: Number(form.SalaryRangeId) || 0,
      IsPublished: mode !== 'draft',   // Save as Draft -> false, Create & Publish -> true
    };

    setSubmitting(true);
    try {
      const response = await postJobSave(payload);
      const code = response?.Data?.JobCode || jobCode || '';
      toster?.current?.success(
        mode === 'draft'
          ? `Job saved as Draft — ${code}`
          : isEdit
            ? `Job updated and published — ${code}`
            : `Job created and published — ${code}`
      );
      setTimeout(() => history.push('/Recruitment/JobsPage'), 1200);
    } catch (err) {
      toster?.current?.error(ERROR_LIST?.JobSave || ERROR_LIST?.TalentRequestList || 'Failed to save job');
    } finally {
      setSubmitting(false);
    }
  };

  const discard = () => {
    if (window.confirm('Discard changes and go back?')) history.push('/Recruitment/JobsPage');
  };

  /* ---------------- render helpers ---------------- */

  const errMsg = (name) => (errors[name] ? <span style={errTextStyle}>{errors[name]}</span> : null);
  const bs = (name) => (errors[name] ? errBorder : undefined);

  const renderOptions = (list) =>
    list.map((o) => (
      <option key={optId(o)} value={optId(o)}>
        {optName(o)}
      </option>
    ));

  const talentRequestLabel = (t) =>
    [t.TalentRequestCode || t.Code || `TR-${t.Id ?? t.id}`, t.Title || t.JobTitle || t.RoleName || t.name]
      .filter(Boolean)
      .join(' · ');

  const visibilityHint = (name = '') => {
    const n = name.toLowerCase();
    if (n.includes('both')) return 'Internal employees + public ATS listing';
    if (n.includes('external')) return 'Public on ats.orggenie.com for all applicants';
    if (n.includes('internal')) return 'Visible to existing employees for internal moves';
    return '';
  };

  const employeeOptionTemplate = (option) => (
    <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
      <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
      <span>{option.FullName}</span>
    </div>
  );

  const renderBullets = (type, list, numClass) =>
    list.map((value, idx) => (
      <li className="bullet-item" key={`${type}-${idx}`}>
        <span className={`bullet-num ${numClass || ''}`}>{idx + 1}</span>
        <input
          className="bullet-input"
          value={value}
          placeholder="Add a criterion…"
          onChange={(e) => updateBullet(type, idx, e.target.value)}
        />
        <button type="button" className="bullet-remove" onClick={() => removeBullet(type, idx)}>
          <i className="fa-solid fa-times bullet-remove-icon"></i>
        </button>
      </li>
    ));

  const renderTags = (list, type, inputId, errorKey) => (
    <>
      <div
        className="tag-input-wrap"
        style={errorKey ? bs(errorKey) : undefined}
        onClick={() => document.getElementById(inputId)?.focus()}
      >
        {list.map((skill, idx) => (
          <span className={`tag-item ${type}`} key={`${skill}-${idx}`}>
            {skill}
            <button type="button" onClick={() => removeTag(idx, type)}>×</button>
          </span>
        ))}
        <input
          id={inputId}
          className="tag-text-input"
          placeholder="Type and press Enter…"
          onKeyDown={(e) => addTag(e, type)}
        />
      </div>
      {errorKey && errMsg(errorKey)}
    </>
  );

  /* ---------------- render ---------------- */

  const userName = userDetails?.FullName || userDetails?.Name || '';
  const userInitials = (userName || 'U').trim().slice(0, 2).toUpperCase();

  const descOk = descLength >= MIN_DESC_LENGTH;
  const descCounterStyle = { color: descOk ? '#16a34a' : descLength > 0 ? '#dc2626' : undefined };

  return (
    <>
      <div className="topbar">
        <i className="fa-solid fa-briefcase"></i>
        <div className="breadcrumb topbar-breadcrumb">
          <a>Recruitment</a>
          <i className="fa-solid fa-chevron-right"></i>
          <a>Jobs</a>
          <i className="fa-solid fa-chevron-right"></i>
          <strong className="topbar-current">{isEdit ? 'Edit Job' : 'Create Job'}</strong>
        </div>
        <div className="top-right">
          <div className="top-user">
            <div className="top-avatar">{userInitials}</div>
            <div>
              <div className="top-user-name">{userName}</div>
              <div className="top-user-role">{userDetails?.RoleName || ''}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid position-relation">
        <div className="page-hd">
          <div className="Page-head">
            <div className="leftside-head">
              <h2>
                <i className={`fa-solid ${isEdit ? 'fa-pen' : 'fa-plus-circle'}`}></i>
                {isEdit ? 'Edit Job' : 'Create Job'}
              </h2>
              <div className="breadcrumb">Fill in job details, requirements and visibility settings</div>
            </div>
            <Link to="/Recruitment/JobsPage" className="btn btn-outline btn-sm btn-gray">
              <i className="fa-solid fa-arrow-left"></i> Back
            </Link>
          </div>
        </div>

        <div className="form-layout">
          <div className="form-nav">
            {NAV_ITEMS.map((item) => (
              <div
                key={item.id}
                className={`fn-item ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => scrollTo(item.id)}
              >
                <i className={`fa-solid ${item.icon}`}></i> {item.label}
              </div>
            ))}
          </div>

          <div className="form-sections">
            {loading && <div className="job-id-preview">Loading…</div>}

            <div className="job-id-preview">
              <i className="fa-solid fa-hashtag"></i>
              <strong>{jobCode || 'JOB-XXXX-XXX'}</strong>
              <span>{isEdit ? 'Job code · read-only' : 'Auto-generated on save · read-only'}</span>
            </div>

            {/* SECTION 1 - Basic Info */}
            <div className="fs-bx" id="s-basic">
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-circle-info"></i>
                <h4>Basic Information</h4>
              </div>
              <div className="fs-body">
                <div className="form-row form-row-1">
                  <div className="fg">
                    <label>Job Title <span className="req">*</span></label>
                    <input
                      id="f-Title"
                      className="og-input"
                      style={bs('Title')}
                      placeholder="e.g. Senior Product Designer"
                      value={form.Title}
                      onChange={(e) => setField('Title', e.target.value)}
                    />
                    {errMsg('Title')}
                  </div>
                </div>

                <div className="form-row form-row-2">
                  <div className="fg">
                    <label>Department <span className="req">*</span></label>
                    <select
                      id="f-DepartmentId"
                      className="og-select"
                      style={bs('DepartmentId')}
                      value={form.DepartmentId}
                      onChange={(e) => setField('DepartmentId', e.target.value)}
                    >
                      <option value="">Select department</option>
                      {renderOptions(departments)}
                    </select>
                    {errMsg('DepartmentId')}
                  </div>

                  <div className="fg">
                    <label>Number of Openings <span className="req">*</span></label>
                    <input
                      id="f-NumberOfOpenings"
                      className="og-input"
                      style={bs('NumberOfOpenings')}
                      type="number"
                      min="1"
                      placeholder="1"
                      value={form.NumberOfOpenings}
                      onChange={(e) => setField('NumberOfOpenings', e.target.value)}
                    />
                    {errMsg('NumberOfOpenings')}
                  </div>
                </div>

                <div className="form-row form-row-1">
                  <div className="fg">
                    <label>Link to Talent Request <span className="opt">(optional)</span></label>
                    <select
                      className="og-select"
                      value={form.TalentRequestId}
                      onChange={(e) => setField('TalentRequestId', e.target.value)}
                    >
                      <option value="">None — standalone job</option>
                      {talentRequests.map((t) => (
                        <option key={t.Id ?? t.id} value={t.Id ?? t.id}>
                          {talentRequestLabel(t)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* SECTION 2 - Job Details */}
            <div className="fs-bx" id="s-details">
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-sliders"></i>
                <h4>Job Details</h4>
              </div>
              <div className="fs-body">
                <div className="form-row form-row-3">
                  <div className="fg">
                    <label>Employment Type <span className="req">*</span></label>
                    <select
                      id="f-EmploymentTypeId"
                      className="og-select"
                      style={bs('EmploymentTypeId')}
                      value={form.EmploymentTypeId}
                      onChange={(e) => setField('EmploymentTypeId', e.target.value)}
                    >
                      <option value="">Select type</option>
                      {renderOptions(employmentTypeList)}
                    </select>
                    {errMsg('EmploymentTypeId')}
                  </div>

                  <div className="fg">
                    <label>Work Mode <span className="req">*</span></label>
                    <select
                      id="f-WorkModeId"
                      className="og-select"
                      style={bs('WorkModeId')}
                      value={form.WorkModeId}
                      onChange={(e) => setField('WorkModeId', e.target.value)}
                    >
                      <option value="">Select work mode</option>
                      {renderOptions(workModeList)}
                    </select>
                    {errMsg('WorkModeId')}
                  </div>

                  <div className="fg">
                    <label>Location <span className="req">*</span></label>
                    <input
                      id="f-Location"
                      className="og-input"
                      style={bs('Location')}
                      placeholder="City or Remote"
                      value={form.Location}
                      onChange={(e) => setField('Location', e.target.value)}
                    />
                    {errMsg('Location')}
                  </div>
                </div>

                <div className="form-row form-row-2">
                  <div className="fg">
                    <label>Experience Range <span className="req">*</span></label>
                    <select
                      id="f-ExperienceRangeId"
                      className="og-select"
                      style={bs('ExperienceRangeId')}
                      value={form.ExperienceRangeId}
                      onChange={(e) => setField('ExperienceRangeId', e.target.value)}
                    >
                      <option value="">Select experience</option>
                      {renderOptions(experienceRangeList)}
                    </select>
                    {errMsg('ExperienceRangeId')}
                  </div>

                  <div className="fg">
                    <label>Expected Start Date</label>
                    <input
                      className="og-input experience-input"
                      type="date"
                      value={form.ExpectedStartDate}
                      onChange={(e) => setField('ExpectedStartDate', e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-row form-row-2">
                  <div className="fg">
                    <label>Notice Period (days)</label>
                    <input
                      className="og-input"
                      type="number"
                      min="0"
                      placeholder="e.g. 30"
                      value={form.NoticePeriodDays}
                      onChange={(e) => setField('NoticePeriodDays', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* SECTION 3 - Compensation */}
            <div className="fs-bx" id="s-comp">
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-indian-rupee-sign"></i>
                <h4>Compensation</h4>
              </div>
              <div className="fs-body">
                <div className="form-row form-row-2">
                  <div className="fg">
                    <label>Salary</label>
                    <select
                      className="og-select"
                      value={form.SalaryRangeId}
                      onChange={(e) => setField('SalaryRangeId', e.target.value)}
                    >
                      <option value="">Select salary range</option>
                      {renderOptions(salaryRangeList)}
                    </select>
                  </div>
                </div>

                <label className="negotiable-label">
                  <input
                    type="checkbox"
                    checked={form.IsSalaryNegotiable}
                    onChange={(e) => setField('IsSalaryNegotiable', e.target.checked)}
                  />
                  Mark as negotiable — exact range hidden from candidates
                </label>
              </div>
            </div>

            {/* SECTION 4 - Must Have */}
            <div className="fs-bx" id="s-must">
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-star"></i>
                <h4>Must Have Requirements</h4>
                <span className="fs-subtitle">Non-negotiable qualifications</span>
              </div>
              <div className="fs-body">
                <div className="form-row form-row-1">
                  <div className="fg">
                    <label>Required Skills <span className="req">*</span></label>
                    {renderTags(mustSkills, 'must', 'mustSkillInput', 'MustSkills')}
                  </div>
                </div>

                <div className="form-row form-row-1">
                  <div className="fg">
                    <label>
                      Must-have criteria <span className="opt">— bullet points shown in job posting</span>
                    </label>
                    <ul className="bullet-list" id="mustList">
                      {renderBullets('must', mustBullets)}
                    </ul>
                    <button type="button" className="add-bullet-btn" onClick={() => addBullet('must')}>
                      <i className="fa-solid fa-plus bullet-remove-icon"></i>
                      Add criterion
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* SECTION 5 - Preferred */}
            <div className="fs-bx" id="s-pref">
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-thumbs-up"></i>
                <h4>Preferred Requirements</h4>
                <span className="fs-subtitle">Nice-to-have qualifications</span>
              </div>
              <div className="fs-body">
                <div className="form-row form-row-1">
                  <div className="fg">
                    <label>Preferred Skills <span className="opt">(nice to have)</span></label>
                    {renderTags(prefSkills, 'pref', 'prefSkillInput')}
                  </div>
                </div>

                <div className="form-row form-row-1">
                  <div className="fg">
                    <label>Preferred criteria <span className="opt">— bonus qualifications</span></label>
                    <ul className="bullet-list" id="prefList">
                      {renderBullets('pref', prefBullets, 'bullet-num-green')}
                    </ul>
                    <button
                      type="button"
                      className="add-bullet-btn add-bullet-green"
                      onClick={() => addBullet('pref')}
                    >
                      <i className="fa-solid fa-plus bullet-remove-icon"></i>
                      Add criterion
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* SECTION 6 - Job Description */}
            <div className="fs-bx" id="s-jd">
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-file-lines"></i>
                <h4>Job Description <span className="req">*</span></h4>
              </div>
              <div className="fs-body">
                <textarea
                  className="og-textarea"
                  style={bs('JobDescription')}
                  rows="12"
                  id="jobDesc"
                  value={form.JobDescription}
                  onChange={(e) => setField('JobDescription', e.target.value)}
                  placeholder={`Describe the role, team context, day-to-day responsibilities, and what success looks like in this position.

Example:
We are looking for a Senior Frontend Developer to join our growing engineering team at BizBrolly. You will work closely with designers and backend engineers to build delightful, high-performance user interfaces for OrgGenie, our flagship SaaS product.

Responsibilities:
• Build and maintain reusable UI components
• Collaborate with design team on new features
• Participate in code reviews and architectural discussions`}
                ></textarea>
                {errMsg('JobDescription')}

                <div className="description-footer">
                  <span className="description-info">Minimum {MIN_DESC_LENGTH} characters required to publish</span>
                  <span id="charCount" className="char-count" style={descCounterStyle}>
                    {descLength} / {MIN_DESC_LENGTH} min
                  </span>
                </div>
              </div>
            </div>

            {/* SECTION 7 - Visibility */}
            <div className="fs-bx" id="s-vis">
              <div className="fs-head">
                <i className="fs-icon fa-solid fa-eye"></i>
                <h4>Visibility &amp; Publishing</h4>
              </div>
              <div className="fs-body">
                <div className="fg visibility-field">
                  <label>Who can see this job? <span className="req">*</span></label>
                  <div className="vis-options">
                    {visibilityList.length === 0 && (
                      <div className="feedback-note">
                        Visibility options could not be loaded. Refresh the page or contact admin.
                      </div>
                    )}
                    {visibilityList.map((v) => {
                      const vid = optId(v);
                      const selected = String(form.VisibilityId) === String(vid);
                      return (
                        <div
                          key={vid}
                          className={`vis-opt ${selected ? 'selected' : ''}`}
                          onClick={() => setField('VisibilityId', vid)}
                        >
                          <input
                            type="radio"
                            name="vis"
                            checked={selected}
                            onChange={() => setField('VisibilityId', vid)}
                          />
                          <div>
                            <div className="vis-opt-label">{optName(v)}</div>
                            <div className="vis-opt-sub">{visibilityHint(optName(v))}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {errMsg('VisibilityId')}
                </div>

                <div className="form-row form-row-2">
                  <div className="fg">
                    <label>Assigned Recruiters</label>
                    <MultiSelect
                      className="w-full"
                      value={form.RecruiterEmpIds}
                      onChange={(e) => setField('RecruiterEmpIds', e.value)}
                      options={employeeList}
                      optionLabel="FullName"
                      optionValue="_id"
                      itemTemplate={employeeOptionTemplate}
                      display="chip"
                      filter
                      filterBy="FullName"
                      showClear
                      maxSelectedLabels={3}
                      placeholder="Select recruiters"
                    />
                  </div>

                  <div className="fg">
                    <label>Feedback Aspects <span className="opt">— used in interviews</span></label>
                    <select
                      className="og-select"
                      value={form.FeedbackAspectTypeId}
                      onChange={(e) => setField('FeedbackAspectTypeId', Number(e.target.value))}
                    >
                      <option value={FEEDBACK_TYPE.DEFAULT}>Use org default aspects</option>
                      <option value={FEEDBACK_TYPE.CUSTOM}>Customise for this job</option>
                    </select>
                  </div>
                </div>

                {Number(form.FeedbackAspectTypeId) === FEEDBACK_TYPE.CUSTOM && (
                  <div id="feedbackNote" className="feedback-note">
                    <i className="fa-solid fa-circle-info"></i>
                    You can add or edit feedback aspects after creating the job, from the interview round setup.
                  </div>
                )}
              </div>
            </div>

            <div className="form-bottom-space"></div>
          </div>
        </div>
      </div>

      {/* Form Footer */}
      <div className="form-footer">
        <button type="button" className="btn btn-outline btn-sm" disabled={submitting} onClick={discard}>
          Discard
        </button>
        <button
          type="button"
          className="btn btn-outline btn-sm"
          disabled={submitting}
          onClick={() => saveJob('draft')}
        >
          <i className="fa-regular fa-floppy-disk"></i> Save as Draft
        </button>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          disabled={submitting}
          onClick={() => saveJob('active')}
        >
          <i className="fa-solid fa-check"></i>{' '}
          {submitting ? 'Saving…' : isEdit ? 'Update & Publish' : 'Create & Publish'}
        </button>
      </div>
    </>
  );
};

export default CreateJob;